<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
      <b-card :header="caption">
        <div style="text-align:right;margin:0px 0px 10px 0px">
            <b-button variant="primary" size="sm" @click="userAdd()" v-b-tooltip.hover title="Add">
              <i class="fa fa-plus" ></i>&nbsp;ADD
            </b-button>
        </div>
        <b-row>    
          <b-col cols="4" xl="4">
            <b-form inline>
                <label class="mr-sm-2" for="inlineInput1">Limit: </label>
                <b-form-select id="limit"
                  :plain="true"
                  v-model="limit"
                  :options="[10,25,50,100]">
                </b-form-select>
            </b-form>
          </b-col> 
          <b-col cols="5" xl="5">

          </b-col>
          <b-col cols="3" xl="3">
            <b-form-input type="text" id="search" placeholder="Search.." v-model="q" ></b-form-input>
          </b-col>
        </b-row>
        <br/>
        
        <b-alert :variant="msg_type"
              v-if="msg"
              dismissible
              :show="msg!=''"
              @dismissed="msg=''">
            {{msg}}
        </b-alert>
        <div class="table-responsive">
        <table v-if="!isLoading"  aria-busy="false" aria-colcount="5" class="table b-table table-striped table-hover">
            <thead class="">
                <tr>
                    <th aria-colindex="1" class="">#</th>
                    <th aria-colindex="2" class="">Name</th>
                    <th aria-colindex="3" class="">Img</th>
                    <th aria-colindex="4" class="">Date</th>
                    <th aria-colindex="1" class=""></th>
                </tr>
            </thead>
            <!---->
            <tbody class="">
              <tr v-for="(item,index) in items" >
                <td>{{getNumber(index)}}</td>
                <td>{{item.name}}</td>
                <td>
                  <img v-if="item.img" :src="item.img" width="100px" />
                </td>
                <td>{{item.created_at | toDateFormat}}</td>
                <td>
                  <b-button size="sm" variant="info" class="btn-sm" @click="userEdit(item.id)" v-b-tooltip.hover title="Edit"><i class="fa fa-pencil"></i></b-button>
                  <b-button size="sm" variant="danger" class="btn-sm" @click="userDelete(item.id)" v-b-tooltip.hover title="Delete"><i class="fa fa-trash"></i></b-button>
                </td>
              </tr>
            </tbody>
        </table>
        </div>
        <square v-if="isLoading"></square>
        
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="limit" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card>
      </transition>
    </b-col>
    
    <b-modal title="Alert" size="sm" class="modal-danger" v-model="deleteModal" @ok="deleteAction()" ok-variant="danger">
      Are you sure want to delete?
    </b-modal>
  </b-row>
</template>

<script>

//import usersData from './UsersData'
export default {
  name: 'Galeries',
  mounted() {
    this.getDatas(1,this.limit);
    this.msg = this.$route.query.msg;
    this.msg_type = this.$route.query.msg_type;
  },
  props: {
    caption: {
      type: String,
      default: 'Galeries'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'id'},
        {key: 'name'},
        {key: 'image'},
        {key: 'date'},
      ],
      currentPage: 1,
      totalRows: 0,
      limit:10,
      q:'',
      deleteModal:false,
      isLoading:true,
      id:'',
      order:'',
      msg:'',
      msg_type:'',
    }
  },
  computed: {
  },
  watch: {
        q: function (q) {
          this.getDatas(1,this.limit,q);
        },
        limit: function (limit) {
          this.getDatas(1,limit,this.q);
        },
        currentPage:function(cp,cpo){
          console.log(cp,cpo);
          this.getDatas(cp,this.limit,this.q);
        }
  },
  methods: {
    getNumber(index){
      return (parseInt(index)+1) +((parseInt(this.currentPage)-1) *parseInt(this.limit));
    },
    getBadge (status) {
      return status ===  null ? 'success': 'danger'
    },
    getRowCount (items) {
      return items.length
    },
    userAdd(){
      this.$router.push({path: 'galery/add'});
    },
    userEdit(id){
      this.$router.push({path: `galery/edit/${id}`});
    },
    userDelete(id){
      this.deleteModal = true;
      this.id = id;
    },
    deleteAction(){
      var app = this;
      var url = this.end_point+'galery/'+this.id;
      axios.delete(url, {})
      .then(function (resp) {
        console.log(resp);
        
          app.error = false;
          app.$notify.success(resp.data.msg);
          app.getDatas(1);
      })
      .catch(function (resp) {
          app.$notify.error(app.setting.msg_con);
          app.error = true;
      });
    },
    onChange(){
    },
    getDatas(page,limit='10',q='',order='a.name ASC'){
      var app = this;
      if (typeof page === 'undefined') {
            page = 1;
      }
      
      this.isLoading = true;
      axios.get(this.end_point+'galery?q='+q+'&page='+page+'&limit='+limit+'&order='+order)
      .then(function (resp) {
        app.isLoading = false;
          if(resp.data.error){          
            app.$notify.error('Could not load data ');

            return false;
          }
          //console.log(resp.data.rows);
          app.currentPage = page;
          app.items = resp.data.data;
          //app.items.push(...resp.data.rows);
          app.totalRows = resp.data.total;
      })
      .catch(function (resp) {
          app.isLoading = false;
          //console.log(resp);
          app.$notify.error('Could not load data ');
      });
    },
    alert(pesan) {
      this.$notify.error('Could not load data ');
    },

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
